<template>
  <client-only>
    <BaseLink to="/" aria-label="Patchstack Logo">
      <Vue3Lottie
        :animation-data="animation"
        :height="20"
        :width="180"
        :auto-play="isPlaying"
        :play-on-hover="false"
        @on-loop-complete="isPlaying = false"
        @mouseenter="isPlaying = true"
      />
    </BaseLink>
  </client-only>
</template>

<script setup>
  import { Vue3Lottie } from 'vue3-lottie';
  import animation from '@/assets/animations/logo-anim.json';
  const isPlaying = ref(false);
</script>
